import React from 'react';
import { useReturnStore } from '@src/stores/returnStore';
import { HrtvEligibilityMap, ItemToReturn } from '@src/models/returns';
import { QuantityItem } from './QuantityItem';

interface QuantitySelectionItemsProps {
  hrtvItemEligibility?: HrtvEligibilityMap;
}

const QuantitySelectionItems = ({
  hrtvItemEligibility,
}: QuantitySelectionItemsProps) => {
  const selectedItems = useReturnStore((state) => state.selectedItems);

  return (
    <div className="sui-flex sui-flex-col sui-gap-12">
      {selectedItems?.map((item: ItemToReturn) => {
        const isHrtvIneligible =
          hrtvItemEligibility?.[item.lineItemId || ''] === false;
        return (
          <div key={item.lineItemId}>
            {item.currentQuantity > 0 && (
              <QuantityItem
                item={item}
                selectedItems={selectedItems}
                isHrtvIneligible={isHrtvIneligible}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default QuantitySelectionItems;
